import React, { FC } from 'react';

import { Badge, type BadgeProps } from 'app/design-system/legacy-components/Badge';
import { type DictionaryData, useTranslation } from 'app/lang';

import dictionary from './LiveBadge.dictionary.json';

export enum BadgePreset {
  STAKE_LIVE = 'STAKE_LIVE',
  BET_LIVE = 'BET_LIVE',
}

type BadgeDataValue = {
  TEXT: string;
  TITLE: DictionaryData;
};

const BadgeData: Record<BadgePreset, BadgeDataValue> = {
  [BadgePreset.STAKE_LIVE]: {
    TEXT: 'LIVE',
    TITLE: dictionary.stakeTitle,
  },
  [BadgePreset.BET_LIVE]: {
    TEXT: 'LIVE',
    TITLE: dictionary.betTitle,
  },
};

type LiveBadgeProps = BadgeProps & {
  preset?: BadgePreset;
};

const LiveBadge: FC<LiveBadgeProps> = (props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Badge text={props.preset ? BadgeData[props.preset].TEXT : ''}
           title={props.preset ? t(BadgeData[props.preset].TITLE) : ''}
           {...props} />
  );
};

export default LiveBadge;
export * from 'app/design-system/legacy-components/Badge';
